import React from 'react';
import { ResultItem } from './partials';
export var SuggestionItem = function SuggestionItem(_ref) {
  var children = _ref.children,
    isSelected = _ref.isSelected,
    index = _ref.index,
    setSelectedSuggestion = _ref.setSelectedSuggestion,
    clickedSuggestion = _ref.clickedSuggestion,
    title = _ref.title;
  var handleMouseDown = function handleMouseDown(event) {
    event.preventDefault();
  };
  var handleClick = function handleClick() {
    clickedSuggestion(index);
  };
  var handleMouseEnter = function handleMouseEnter() {
    setSelectedSuggestion(index);
  };
  return React.createElement(ResultItem, {
    onMouseDown: handleMouseDown,
    onClick: handleClick,
    onMouseEnter: handleMouseEnter,
    isSelected: isSelected,
    title: title
  }, children);
};